/*eslint no-script-url: 0 */
import React, { Component } from "react";
import Constants from '../../Config/Config';
import DropzoneComponent from 'react-dropzone-component';

export default class ImageFile extends Component {
	constructor(props) {
        super(props);
		// For a full list of possible configurations,
        // please consult http://www.dropzonejs.com/#configuration
        this.djsConfig = {
            addRemoveLinks: true,
			acceptedFiles: "image/jpeg,image/png,image/gif",
			maxFilesize: 20, // MB
        };

        this.componentConfig = {
            iconFiletypes: ['.jpg', '.png', '.gif'],
            showFiletypeIcon: true,
            autoProcessQueue: true,
            postUrl: Constants.URL.root+'/webservices/uploadImage.php'
        };

        // If you want to attach multiple callbacks, simply
        // create an array filled with all your callbacks.
        this.callbackArray = [() => console.log('Hi!'), () => console.log('Ho!')];

        // Simple callbacks work too, of course
        this.callback = (file) => console.log('Hello!', file);

        this.success = (file, response) => {
        	// console.log(response);
        	var self = this;
        	//this.props.lgClose();
        	this.dispatchImageData(response);
			var NImage = new Image();
			NImage.src = response
			NImage.onload = function() {
				var O = (NImage.src.replace(/.*?:\/\//g, '/'), 0);
                var P = 0;
                //var Q;
                O = NImage.width
                P = NImage.height
                /* if (150 < O / 30) {
                    Q = P / O;
                    O = 4500
                    P = O * Q
                }
                if (100 < P / 30) {
                    Q = P / O;
                    P = 3000
                    O = P * Q
                } */
				self.props.dispatch({
					type: 'SET_STATE',
					state: {
						aspectRatio: parseFloat(NImage.width) / parseFloat(NImage.height),
						frameImageHeight: (P / 30).toFixed(1),
						frameImageWidth: (O / 30).toFixed(1),
						uploadedImageHeight: (P / 30).toFixed(1),
						uploadedImageWidth: (O / 30).toFixed(1),
					}
				})
			}
			if (self.props.isUploadingFalse !== undefined) {
				self.props.isUploadingFalse();
				self.props.handleShow();
			}
        }

        this.removedfile = file => console.log('removing...', file);

        this.dropzone = null;
    }

	dispatchImageData(ImageData) {
		const data = ImageData;
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				uploadedFile: data,
				frameImage: data
			}
		})
	}

 	render() {
 	 	const config = this.componentConfig;
		const djsConfig = this.djsConfig;
		// For a list of all possible events (there are many), see README.md!
		const eventHandlers = {
			init: dz => this.dropzone = dz,
			drop: this.callbackArray,
			addedfile: this.callback,
			success: this.success,
			removedfile: this.removedfile
		}
	    return (
	    	<DropzoneComponent config={config} eventHandlers={eventHandlers} djsConfig={djsConfig}>
				<div className="dz-message">
					Drop files here to upload
					<span>Max upload file size is 20MB</span>
				</div>
			</DropzoneComponent>
	    );
  	}
}